<template>
  <div id="politique-confidentialite" class="gip-max-width">
    <h1>Politique de confidentialité – GIP Cafés Cultures</h1>

    <p class="mise-a-jour">Dernière mise à jour : 19/01/2026</p>

    <p>Le GIP Cafés Cultures attache une grande importance à la protection des données personnelles de ses utilisateurs. La présente politique de confidentialité explique comment les données sont collectées, utilisées et protégées dans le cadre de l'utilisation de l'application mobile GIP Cafés Cultures.</p>

    <h2>1. Données collectées</h2>
    <p>L'application peut collecter les données fournies volontairement par l'utilisateur, notamment :</p>
    <ul>
      <li>informations d'identification (nom, prénom, adresse e-mail)</li>
      <li>informations liées à l'utilisation du service (formulaires, demandes, contenus saisis)</li>
    </ul>
    <p>Aucune donnée n'est collectée à l'insu de l'utilisateur.</p>

    <h2>2. Utilisation des données</h2>
    <p>Les données collectées sont utilisées exclusivement à des fins internes, notamment pour :</p>
    <ul>
      <li>le fonctionnement et l'amélioration de l'application</li>
      <li>le traitement des demandes et dossiers</li>
      <li>la communication liée aux services du GIP Cafés Cultures</li>
    </ul>
    <p>Les données ne sont ni vendues, ni cédées, ni utilisées à des fins commerciales.</p>

    <h2>3. Partage des données</h2>
    <p>Les données personnelles ne sont partagées avec aucun tiers, sauf obligation légale.</p>

    <h2>4. Conservation des données</h2>
    <p>Les données sont conservées uniquement pendant la durée nécessaire à leur utilisation interne et conformément aux obligations légales en vigueur.</p>

    <h2>5. Sécurité</h2>
    <p>Des mesures techniques et organisationnelles sont mises en place afin de garantir la sécurité et la confidentialité des données personnelles.</p>

    <h2>6. Droits des utilisateurs</h2>
    <p>Conformément au Règlement Général sur la Protection des Données (RGPD), l'utilisateur dispose d'un droit d'accès, de rectification et de suppression de ses données.</p>
    <p>Toute demande peut être adressée à : contact@gipcafescultures.fr</p>

    <h2>7. Contact</h2>
    <p>Pour toute question relative à la protection des données personnelles, vous pouvez contacter le GIP Cafés Cultures à l'adresse indiquée ci-dessus.</p>
  </div>
</template>

<script>
export default {
  name: "PolitiqueConfidentialite",
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
#politique-confidentialite {
  padding-top: 4em;
  background: var(--gip-white-color);
  padding-left: 2em;
  padding-right: 2em;
  padding-bottom: 2em;
}

h1 {
  margin-bottom: 1em;
}

h2 {
  margin-top: 1.5em;
  margin-bottom: 0.5em;
}

p {
  margin-bottom: 0.5em;
  line-height: 1.6;
}

ul {
  margin-left: 2em;
  margin-bottom: 0.5em;
}

li {
  margin-bottom: 0.25em;
}

.mise-a-jour {
  font-style: italic;
  color: #666;
  margin-bottom: 1.5em;
}
</style>
